window.addEventListener('DOMContentLoaded', () => {

    document.addEventListener('click', function (e) {
        if (e.target.matches('.faq--handle')) {
            e.target.classList.toggle('open');
        }
    });

});